export const searchMenuItemStyles = {
	position: "sticky",
	top: 0,
	backgroundColor: "white",
	zIndex: 1,
	py: 0.75,
	px: 1,
	minHeight: "unset",
	"&.MuiMenuItem-root": {
		minHeight: "unset",
	},
	"&:hover": {
		backgroundColor: "white",
	},
};

/** Compact search row inside the dropdown only — does not affect the closed select height. */
export const searchTextFieldStyles = {
	"& .MuiOutlinedInput-root": {
		backgroundColor: "#f9fafb",
		fontSize: "14px",
		minHeight: "36px",
		height: "36px",
		"& .MuiOutlinedInput-input": {
			padding: "6px 8px",
			fontSize: "14px",
		},
		"& fieldset": {
			borderColor: "#e5e7eb",
		},
		"&:hover fieldset": {
			borderColor: "#d1d5db",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#2a9699",
		},
	},
}; 